import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function fadeLine() {
  setTimeout(function () {
    // 疑似要素のカスタムプロパティを操作するアニメーション
    const element = document.querySelector(".p-history-content__history-list");

    // gsap.toでカスタムプロパティをアニメーション
    ScrollTrigger.create({
      trigger: element,
      start: "top 50%",
      onEnter: () => {
        gsap.to(element, {
          duration: 10, // アニメーションの時間
          css: {
            "--pseudo-height": "100%", // 目的の高さに変更
          },
          ease: "power1.inOut", // イージング関数
        });
      },
      once: true,
      // markers: true,
    });
  }, 2000);
}
